import React, { Component } from 'react';

export default (importComponent) => (class AsyncComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            component: null
        };
    }

    async componentDidMount() {
        const cmp = await importComponent();
        
        this.setState({ component: cmp.default });
    }

    render() {
        const ImportedComponent = this.state.component;

        return !!this.state.component ? <ImportedComponent {...this.props} /> : null;
    }
});


// WEBPACK FOOTER //
// ./src/hoc/asyncComponent/asyncComponent.js